<template>
  <nav class="navbar is-fixed-top is-blur is-transparent is-elevated">
    <div class="container">
      <div class="navbar-brand">
        <a href="#" class="navbar-item"  @click.prevent="toggleDrawer">
          <span class="icon is-medium">
            <i :class="`fas fa-lg fa-${showDrawer ? 'times' : 'bars'}`"></i>
          </span>
        </a>
      </div>
      <div class="navbar-menu">
        <div class="navbar-start">
          <router-link :to="link.href" :class="'navbar-item '+link.class" v-for="(link, index) in links" :key="index" exact>{{ link.title }}</router-link>
        </div>
        <div class="is-size-4 navbar-item" v-if="$route.name !== 'home'">
          {{$_.upperFirst($tc($route.meta.title || $route.params.app || 'auto-reestr')) }}
        </div>
        <div class="navbar-end">
          <div class="navbar-item py-1" v-if="!('id' in me)">
            <router-link to="/login" class="button is-grey is-light" >
              <span class="icon">
                <i class="fas fa-user"></i>
              </span>
              <span>Авторизация</span>
            </router-link>
          </div>
          <div class="navbar-item has-dropdown is-hoverable" v-else>
            <div class="navbar-link">
              <ul>
                <li class="is-size-7">
                  {{me.email}}
                </li>
                <li class="is-size-7">
                  {{$store.state.user.appointment.profession && $store.state.user.appointment.profession.title || ''}}
                  {{$store.state.user.appointment.profession ? ' - ' : ''}}
                  {{$store.state.user.appointment.profession && $store.state.user.appointment.organization.name || ''}}
                </li>
              </ul>
            </div>

            <div class="navbar-dropdown">
              <div class="navbar-item">
                <strong>{{me.first_name}} {{me.last_name}} {{me.middle_name}}</strong>
              </div>
              <hr class="navbar-divider">
              <router-link to="/me" class="navbar-item has-icon-left" title="открыть профиль">{{me.email}}</router-link>
              <router-link to="/login" class="navbar-item" title="сменить профиль">
                {{$store.state.user.appointment.profession && $store.state.user.appointment.profession.title || 'Должность не назначена'}}
                {{$store.state.user.appointment.profession ? ' - ' : ''}}
                {{$store.state.user.appointment.profession && $store.state.user.appointment.organization.name || ''}}
              </router-link>
              <hr class="navbar-divider">
              <a @click.prevent="logout" class="navbar-item">
                Выход
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  props: {
    showDrawer: Boolean,
    links: {
      href: '',
      title: '',
      icon: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    me () {
      return this.$store.state.user.me
    }
  },
  methods: {
    toggleDrawer () {
      this.$emit('update:show-drawer', !this.showDrawer)
    },
    logout () {
      this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">

</style>
